module.exports = __webpack_public_path__ + "img/header-memoireRingsFullSizeMemoires@2x.67fc9d9.webp";